<template>
  <div v-if="payslipData.username">
    <v-col
      cols="12"
      style="text-align: left; background-color: grey; color: white"
      class="border"
    >
      <div>Tháng: {{ payslipData.month }}/{{ payslipData.year }}</div>
      <div>Tên: {{ payslipData.name }}</div>
      <div>Tên tài khoản: {{ payslipData.username }}</div>
      <div>Chức vụ: {{ payslipData.roles }}</div>
      <div>
        Tổng thu nhập (bằng (21) cộng (24)):
        <template v-if="payslipData.tong_thu_nhap">
          {{
            payslipData.tong_thu_nhap.toLocaleString("vi-VN", {
              style: "currency",
              currency: "VND",
            })
          }}
        </template>
      </div>
    </v-col>

    <v-row>
      <v-col cols="6">
        <b>Chi tiết lương</b>
        <table style="width: 100%">
          <tr>
            <td style="text-align: left">(0) Tổng số ngày công cả tháng:</td>
            <td cols="6" style="text-align: right">
              {{ payslipData.tong_ngay_cong_ca_thang }}
            </td>
          </tr>
          <tr>
            <td style="text-align: left">(1) Số ngày đi làm thực tế:</td>
            <td cols="6" style="text-align: right">
              {{ payslipData.tong_ngay_cong_thuc_te }}
            </td>
          </tr>
          <tr>
            <td style="text-align: left">(2) Số ngày nghỉ hưởng lương:</td>
            <td cols="6" style="text-align: right">
              {{ payslipData.tong_ngay_nghi_huong_luong }}
            </td>
          </tr>
          <tr>
            <td style="text-align: left">
              (3) Số ngày nghỉ không hưởng lương:
            </td>
            <td cols="6" style="text-align: right">
              {{ payslipData.tong_ngay_nghi_khong_huong_luong }}
            </td>
          </tr>
          <tr>
            <td style="text-align: left">
              (4) Tổng số ngày công hưởng lương (bằng (1) cộng (2)):
            </td>
            <td cols="6" style="text-align: right">
              {{ payslipData.tong_ngay_cong_huong_luong }}
            </td>
          </tr>
        </table>

        <br />

        <v-expansion-panels>
          <template v-for="(i, index) in payslipData.chi_tiet_luong">
            <v-expansion-panel :key="index">
              <v-expansion-panel-header>
                <b style="margin-left: -10px"
                  >Từ ngày {{ i.tu_ngay }} đến ngày {{ i.den_ngay }}:</b
                >
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <table style="width: 100%">
                  <tr>
                    <td style="text-align: left">
                      (5) Số ngày công hưởng lương

                      <v-menu
                        :close-on-content-click="false"
                        :nudge-width="200"
                        offset-x
                        persistent
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <a v-bind="attrs" v-on="on"> (xem chi tiết) </a>
                        </template>
                        <v-card
                          class="mx-auto status-scroll"
                          max-width="344"
                          outlined
                        >
                          <v-col
                            cols="12"
                            three-line
                            v-for="(j, jindex) in i.ngay_cong_huong_luong"
                            :key="jindex"
                            class="border"
                            style="text-align: left; font-size: 12px"
                          >
                            <template>
                              <div>
                                <b>Ngày:</b>
                                {{
                                  new Date(j.ngay).getDate() +
                                  "/" +
                                  (new Date(j.ngay).getMonth() + 1) +
                                  "/" +
                                  new Date(j.ngay).getFullYear()
                                }}
                                - <b>Số Công:</b> {{ j.cong }}
                              </div>
                            </template>
                          </v-col>
                        </v-card>
                      </v-menu>
                    </td>
                    <td style="text-align: right">
                      {{ i.tong_ngay_cong_huong_luong }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">(6) Lương theo hợp đồng</td>
                    <td style="text-align: right">
                      <template v-if="i.luong_hop_dong != null">
                        {{
                          i.luong_hop_dong.toLocaleString("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          })
                        }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (7) Lương 1 ngày công (bằng (6) chia (0))
                    </td>
                    <td style="text-align: right">
                      <template v-if="i.luong_1_ngay_cong != null">
                        {{
                          i.luong_1_ngay_cong.toLocaleString("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          })
                        }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (8) Lương thực tế (bằng (7) nhân (5))
                    </td>
                    <td style="text-align: right">
                      <template v-if="i.luong_thuc_te != null">
                        {{
                          i.luong_thuc_te.toLocaleString("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          })
                        }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">(9) Phụ cấp theo hợp đồng</td>
                    <td style="text-align: right">
                      <template v-if="i.phu_cap_hop_dong != null">
                        {{
                          i.phu_cap_hop_dong.toLocaleString("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          })
                        }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (10) Phụ cấp 1 ngày công (bằng (9) chia (0))
                    </td>
                    <td style="text-align: right">
                      <template v-if="i.phu_cap_1_ngay_cong != null">
                        {{
                          i.phu_cap_1_ngay_cong.toLocaleString("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          })
                        }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (11) Phụ cấp thực tế (bằng (10) nhân (5))
                    </td>
                    <td style="text-align: right">
                      <template v-if="i.phu_cap_thuc_te != null">
                        {{
                          i.phu_cap_thuc_te.toLocaleString("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          })
                        }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (12) Lương 1 giờ công (bằng (7) chia 7,5)
                    </td>
                    <td style="text-align: right">
                      <template v-if="i.luong_1_gio_cong != null">
                        {{
                          i.luong_1_gio_cong.toLocaleString("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          })
                        }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <hr />
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (13.1) Số giờ tăng ca các ngày trong tuần
                    </td>
                    <td style="text-align: right">
                      {{ i.so_gio_tang_ca_trong_tuan }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (14.1) Số giờ tăng ca các ngày cuối tuần
                    </td>
                    <td style="text-align: right">
                      {{ i.so_gio_tang_ca_cuoi_tuan }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (15.1) Số giờ tăng ca các ngày ngày lễ
                    </td>
                    <td style="text-align: right">
                      {{ i.so_gio_tang_ca_ngay_le }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (16.1) Số giờ tăng ca trong tháng (bằng (13.1) nhân 150%
                      cộng (14.1) nhân 200% cộng (15.1) nhân 300%)
                    </td>
                    <td style="text-align: right">
                      {{ i.so_gio_tang_ca_trong_thang }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (17.1) Lương tăng ca (bằng (16) nhân (12))
                    </td>
                    <td style="text-align: right">
                      <template v-if="i.luong_tang_ca != null">
                        {{
                          i.luong_tang_ca.toLocaleString("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          })
                        }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <hr />
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (13.2) Số giờ làm ở nhà các ngày trong tuần
                    </td>
                    <td style="text-align: right">
                      {{ i.so_gio_lam_o_nha_trong_tuan }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (14.2) Số giờ làm ở nhà các ngày cuối tuần
                    </td>
                    <td style="text-align: right">
                      {{ i.so_gio_lam_o_nha_cuoi_tuan }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (15.2) Số giờ làm ở nhà các ngày ngày lễ
                    </td>
                    <td style="text-align: right">
                      {{ i.so_gio_lam_o_nha_ngay_le }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (16.2) Số giờ làm ở nhà trong tháng (bằng (13.2) nhân 70%
                      cộng (14.2) nhân 140% cộng (15.2) nhân 210%)
                    </td>
                    <td style="text-align: right">
                      {{ i.so_gio_lam_o_nha_trong_thang }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left">
                      (17.2) Lương làm ở nhà (bằng (16.2) nhân (12))
                    </td>
                    <td style="text-align: right">
                      <template v-if="i.luong_lam_o_nha != null">
                        {{
                          i.luong_lam_o_nha.toLocaleString("vi-VN", {
                            style: "currency",
                            currency: "VND",
                          })
                        }}
                      </template>
                    </td>
                  </tr>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </v-expansion-panels>
        <!-- <v-col
          cols="12"
          class="border"

          :key="index"
          style="text-align: left"
        >


        </v-col> -->

        <br />

        <table style="width: 100%">
          <tr>
            <td style="text-align: left">(18) Bảo hiểm</td>
            <td style="text-align: right">
              <template v-if="payslipData.bao_hiem != null">
                {{
                  payslipData.bao_hiem.toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })
                }}
              </template>
            </td>
          </tr>
          <tr>
            <td style="text-align: left">
              (19) Đi muộn {{ payslipData.tong_so_phut_di_muon }} phút về sớm
              {{ payslipData.tong_so_phut_ve_som }} phút (Cập nhật lần cuối lúc:
              {{ payslipData.attendance_machine_last_sync }})
              <v-menu
                :close-on-content-click="false"
                :nudge-width="200"
                offset-x
                persistent
                v-if="payslipData.chi_tiet_di_muon_ve_som.length > 0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <a v-bind="attrs" v-on="on"> (xem chi tiết) </a>
                </template>
                <v-card class="mx-auto status-scroll" max-width="344" outlined>
                  <v-col
                    cols="12"
                    three-line
                    v-for="(i, index) in payslipData.chi_tiet_di_muon_ve_som"
                    :key="index"
                    class="border"
                    style="text-align: left; font-size: 12px"
                  >
                    <template>
                      <div>
                        <b>Ngày:</b>
                        {{
                          new Date(i.ngay).getDate() +
                          "/" +
                          (new Date(i.ngay).getMonth() + 1) +
                          "/" +
                          new Date(i.ngay).getFullYear()
                        }}
                      </div>
                      <div>
                        <b>Thời gian chấm công:</b>
                        {{ i.van_tay }}
                      </div>

                      <div>
                        <b>Ghi chú:</b>
                        {{ i.ghi_chu }}
                      </div>
                    </template>
                  </v-col>
                </v-card>
              </v-menu>
            </td>
            <td style="text-align: right">
              <template v-if="payslipData.di_muon_ve_som != null">
                {{
                  payslipData.di_muon_ve_som.toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })
                }}
              </template>
            </td>
          </tr>
          <tr>
            <td style="text-align: left">
              (20) Quên chấm công
              {{ payslipData.tong_so_lan_quen_cham_cong }} lần (Cập nhật lần
              cuối lúc: {{ payslipData.attendance_machine_last_sync }})
              <template v-if="payslipData.chi_tiet_quen_cham_cong">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                  persistent
                  v-if="payslipData.chi_tiet_quen_cham_cong.length > 0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on"> (xem chi tiết) </a>
                  </template>
                  <v-card
                    class="mx-auto status-scroll"
                    max-width="344"
                    outlined
                  >
                    <v-col
                      cols="12"
                      three-line
                      v-for="(i, index) in payslipData.chi_tiet_quen_cham_cong"
                      :key="index"
                      class="border"
                      style="text-align: left; font-size: 12px"
                    >
                      <template>
                        <div>
                          <b>Ngày:</b>
                          {{
                            new Date(i.ngay).getDate() +
                            "/" +
                            (new Date(i.ngay).getMonth() + 1) +
                            "/" +
                            new Date(i.ngay).getFullYear()
                          }}
                        </div>
                        <div>
                          <b>Thời gian chấm công:</b>
                          {{ i.van_tay }}
                        </div>

                        <div>
                          <b>Ghi chú:</b>
                          {{ i.ghi_chu }}
                        </div>
                      </template>
                    </v-col>
                  </v-card>
                </v-menu>
              </template>
            </td>
            <td style="text-align: right">
              <template v-if="payslipData.quen_cham_cong != null">
                {{
                  payslipData.quen_cham_cong.toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })
                }}
              </template>
            </td>
          </tr>
          <tr>
            <td style="text-align: left">
              <b style="color: red"
                >(21) Lương thực lĩnh (bằng (8) cộng (11) cộng (17.1) cộng
                (17.2) cộng (18) cộng (19)):</b
              >
            </td>
            <td style="text-align: right">
              <template v-if="payslipData.luong_thuc_linh != null">
                {{
                  payslipData.luong_thuc_linh.toLocaleString("vi-VN", {
                    style: "currency",
                    currency: "VND",
                  })
                }}
              </template>
            </td>
          </tr>
        </table>
      </v-col>

      <v-col cols="6">
        <b>Chi tiết thưởng</b>
        <v-col cols="12">
          <table style="width: 100%">
            <tr>
              <td style="text-align: left">
                (22) Thưởng (USD)

                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                  persistent
                >
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on"> (xem chi tiết) </a>
                  </template>
                  <v-card
                    class="mx-auto status-scroll"
                    max-width="344"
                    outlined
                  >
                    <v-col
                      cols="12"
                      three-line
                      v-for="(i, index) in payslipData.chi_tiet_thuong"
                      :key="index"
                      class="border"
                      style="text-align: left; font-size: 12px"
                    >
                      <template>
                        <div>
                          <b>Vị trí:</b>
                          {{ i.position_name }}
                        </div>

                        <div>
                          <b>Sales: </b>
                          <template v-if="i.sales">{{ i.sales }}</template>
                          <template v-else>0</template>
                        </div>
                        <div>
                          <b>Thưởng:</b>
                          {{ i.bonus }}
                        </div>
                      </template>
                    </v-col>
                  </v-card>
                </v-menu>
              </td>
              <td style="text-align: right">
                <template v-if="payslipData.tong_thuong_usd != null">
                  {{
                    payslipData.tong_thuong_usd.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })
                  }}
                </template>
              </td>
            </tr>
            <tr>
              <td style="text-align: left">
                (23) Thưởng (VND) (bằng (20) nhân 22.850)
              </td>
              <td style="text-align: right">
                <template v-if="payslipData.tong_thuong_vnd != null">
                  {{
                    payslipData.tong_thuong_vnd.toLocaleString("vi-VN", {
                      style: "currency",
                      currency: "VND",
                    })
                  }}
                </template>
              </td>
            </tr>
            <tr>
              <td style="text-align: left">
                <b style="color: red">(24) Thưởng thực lĩnh (bằng (23))</b>
              </td>
              <td style="text-align: right">
                <template v-if="payslipData.thuong_thuc_linh != null">
                  {{
                    payslipData.thuong_thuc_linh.toLocaleString("vi-VN", {
                      style: "currency",
                      currency: "VND",
                    })
                  }}
                </template>
              </td>
            </tr>
          </table>

          <v-btn color="orange" dark style="margin-top: 10px" @click="close"
            >Đóng</v-btn
          >
        </v-col>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});
export default {
  name: "PayslipDetail",
  props: { data: String },
  data: () => ({
    payslipData: [],
    informText: "",
  }),
  methods: {
    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "payslip-detail-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "payslips/" + this.data, {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("payslip Detail Response: ", response);
            if (response.data.error_message == "") {
              this.payslipData = response.data.data.payslip;
              for (const i of this.payslipData.chi_tiet_luong) {
                i.tu_ngay = moment(i.tu_ngay).format("DD/MM");
                i.den_ngay = moment(i.den_ngay).format("DD/MM");
              }

              this.payslipData.attendance_machine_last_sync = moment(
                this.payslipData.attendance_machine_last_sync
              )
                .tz("Asia/Ho_Chi_Minh")
                .format("DD/MMM/YYYY - HH:mm");
            } else {
              this.informText = response.data.error_message;
            }
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        console.log(
          "currentSession payslip-detail-loadData-undefined: ",
          currentSession
        );
      }
    },

    close() {
      this.$root.$refs.payslips.turnOffDialog();
    },
  },
  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
.status-scroll {
  height: 40vh;
  overflow: auto;
}
</style>